// extracted by mini-css-extract-plugin
export default {"container":"AccountingBookInfo_container__3FRxW","label":"AccountingBookInfo_label__QnmmA"};